import type { Memo } from '@memori-web/shared';

export interface Stats {
  totalDays: number;
  totalChars: number;
  streak: number;
}

export function calculateStats(memos: Memo[], today: string): Stats {
  const visible = memos.filter(m => !m.deletedAt);
  const daySet = new Set(visible.map(m => m.date));
  const totalDays = daySet.size;
  const totalChars = visible.reduce((sum, m) => sum + [...m.content].length, 0);

  // streak: today から逆方向に連続している日数
  let streak = 0;
  if (daySet.has(today)) {
    streak = 1;
    let cursor = today;
    while (true) {
      cursor = previousDay(cursor);
      if (daySet.has(cursor)) streak++;
      else break;
    }
  }
  return { totalDays, totalChars, streak };
}

function previousDay(ymd: string): string {
  const [y, m, d] = ymd.split('-').map(Number);
  const date = new Date(Date.UTC(y!, m! - 1, d!));
  date.setUTCDate(date.getUTCDate() - 1);
  return `${date.getUTCFullYear()}-${String(date.getUTCMonth() + 1).padStart(2, '0')}-${String(date.getUTCDate()).padStart(2, '0')}`;
}
